const runtimeEnv =
  typeof window !== "undefined" && window.__ENV__ ? window.__ENV__ : {};

const viteEnv = typeof import.meta !== "undefined" ? import.meta.env || {} : {};

const normalizeBaseUrl = (value) => {
  if (!value) return "";
  if (/^https?:\/\//i.test(value)) return value;
  if (value.startsWith("//")) return `${window.location.protocol}${value}`;
  return `${window.location.protocol}//${value}`;
};

export const config = {
  VITE_API_BASE_URL: normalizeBaseUrl(
    runtimeEnv.VITE_API_BASE_URL || viteEnv.VITE_API_BASE_URL || ""
  ),
  VITE_AZURE_OAUTH_CLIENT_ID:
    runtimeEnv.VITE_AZURE_OAUTH_CLIENT_ID ||
    viteEnv.VITE_AZURE_OAUTH_CLIENT_ID ||
    "",
  VITE_AZURE_OAUTH_TENANT_ID:
    runtimeEnv.VITE_AZURE_OAUTH_TENANT_ID ||
    viteEnv.VITE_AZURE_OAUTH_TENANT_ID ||
    "",
};
